
import React from 'react';
import { motion } from 'framer-motion';

const performanceData = [
    { id: 1, title: '2024년 상반기 공조 시스템 납품', client: '삼성전자', date: '2024-06-15' },
    { id: 2, title: '강남구청 배연창 설치 공사', client: '강남구청', date: '2024-05-20' },
    { id: 3, title: 'SK하이닉스 환기 시스템 유지보수', client: 'SK하이닉스', date: '2024-04-10' },
    { id: 4, title: '롯데타워 제연 설비 점검', client: '롯데건설', date: '2024-03-05' },
    { id: 5, title: '2023년 하반기 학교 안전 시설 확충', client: '서울시교육청', date: '2023-11-12' },
];

function Performance() {
    return (
        <div className="text-gray-800">
            {/* Hero Section */}
            <section className="relative h-[50vh] bg-[url('hero-bg.jpg')] bg-cover bg-center flex items-center justify-center">
                <div className="absolute inset-0 bg-black bg-opacity-50" />
                <div className="relative z-10 text-center px-4">
                    <h1 className="text-4xl md:text-5xl font-bold text-white">실적이력</h1>
                    <p className="mt-4 text-white text-lg md:text-xl">
                        JDWinTech의 주요 사업 실적을 소개합니다.
                    </p>
                </div>
            </section>

            {/* Bulletin Board Section */}
            <section className="py-16 px-6 md:px-20 max-w-6xl mx-auto">
                <div className="flex justify-between items-end mb-4 border-b pb-4 border-gray-300">
                    <h2 className="text-2xl font-bold text-gray-800">사업 실적</h2>
                    <span className="text-sm text-gray-500">총 {performanceData.length}건</span>
                </div>

                {/* Table / List */}
                <div className="overflow-x-auto">
                    <table className="w-full text-left border-collapse">
                        <thead>
                            <tr className="bg-gray-100 text-gray-700 border-b border-gray-300">
                                <th className="p-4 w-16 text-center font-semibold">No.</th>
                                <th className="p-4 font-semibold">사업명</th>
                                <th className="p-4 w-40 text-center font-semibold">발주처</th>
                                <th className="p-4 w-32 text-center font-semibold">일자</th>
                            </tr>
                        </thead>
                        <tbody>
                            {performanceData.map((item, index) => (
                                <motion.tr
                                    key={item.id}
                                    initial={{ opacity: 0, y: 10 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.3, delay: index * 0.1 }}
                                    viewport={{ once: true }}
                                    className="border-b border-gray-200 hover:bg-gray-50 transition-colors"
                                >
                                    <td className="p-4 text-center text-gray-500">{performanceData.length - index}</td>
                                    <td className="p-4 font-medium text-gray-800">{item.title}</td>
                                    <td className="p-4 text-center text-gray-600">{item.client}</td>
                                    <td className="p-4 text-center text-gray-500">{item.date}</td>
                                </motion.tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    );
}

export default Performance;
